import { Box } from "@mui/material";

const Card = ({
  children,
  padding = 3,
  className = "",
}: {
  children: React.ReactNode;
  padding?: number;
  className?: string;
}) => {
  return (
    <Box
      bgcolor="background.paper"
      color="text.primary"
      p={padding}
      borderRadius={2}
      boxShadow="1px 2px 6px 1px rgba(0, 0, 0, 0.1)"
      className={className}
    >
      {children}
    </Box>
  );
};

export default Card;
